import script from "./navbar_items.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar_items.vue?vue&type=script&setup=true&lang=js"

import "./navbar_items.vue?vue&type=style&index=0&id=4d00f7b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d00f7b9"]])

export default __exports__